import { COMMUNICATION_CHART_LINK_LINE_WIDTH_MAX_PX, COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX } from '@web/components/CommunicationNetworkGraph/core/communicationChart/constants';
export var resolveCommunicationChartLinkWeightRange = function (weights) {
    if (weights.length === 0) {
        return { min: 0, max: 0 };
    }
    return {
        min: Math.min.apply(Math, weights),
        max: Math.max.apply(Math, weights)
    };
};
export var getCommunicationChartLinkWidth = function (weight, weightRange) {
    if (weight <= 0) {
        return 0.5;
    }
    var min = weightRange.min, max = weightRange.max;
    if (max <= 0) {
        return COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX;
    }
    if (max <= min) {
        return COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX;
    }
    var ratio = (weight - min) / (max - min);
    var width = COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX +
        ratio *
            (COMMUNICATION_CHART_LINK_LINE_WIDTH_MAX_PX -
                COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX);
    return Math.min(COMMUNICATION_CHART_LINK_LINE_WIDTH_MAX_PX, Math.max(COMMUNICATION_CHART_LINK_LINE_WIDTH_MIN_PX, width));
};
